"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECommunityInvestmentTooltipTrads = void 0;
exports.ECommunityInvestmentTooltipTrads = {
    reinvestment_of_equity: "Certaines sociétés de gestion sont susceptibles de demander une attestation complémentaire signée par les 2 conjoints",
    mutual_funds: "Certaines sociétés de gestion sont susceptibles de demander soit une attestation de renonciation du conjoint, soit la signature du conjoint sur le bulletin",
};
